import { Fragment } from 'react'
import ReactDom from 'react-dom'

import classes from './MessageBox.module.css'
import close from '../../../images/Close-dark.svg'
import BackdropBlur from './BackdropBlur'

const MessageBox = ({backdropClassName, className, title, onClose, children, backdropVariant = 'heavy'}) => {
    const portalElement = document.getElementById('overlays')

    // createPortal throws on a missing target and takes the whole tree down with it, so do what
    // the other portals in the app do and simply render nothing.
    if (!portalElement) {
        return null
    }

    return (
        <Fragment>
            {ReactDom.createPortal(<BackdropBlur variant={backdropVariant} className={`${classes['message-wrapper']} ${backdropClassName}`}>
            <div className={`${classes.message} ${className}`} data-blocking-layer="">
                <div className={classes['message-header']}>
                <h3 className={classes['message-title']}>{title}</h3>
                <img className={classes['message-close']} src={close} onClick={onClose} alt=''/>
                </div>
                {children}
                </div>
                <div>
                </div>
            </BackdropBlur>, portalElement)}
        </Fragment>
    )
}

export default MessageBox